var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph:play-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45 24C45.0012 24.5093 44.8707 25.0102 44.6209 25.4541C44.3712 25.898 44.0109 26.2697 43.575 26.5331L16.56 43.0593C16.1045 43.3382 15.5829 43.4905 15.0489 43.5004C14.5149 43.5103 13.988 43.3774 13.5225 43.1156C13.0615 42.8578 12.6774 42.4819 12.4098 42.0264C12.1422 41.571 12.0008 41.0525 12 40.5243V7.47558C12.0008 6.94737 12.1422 6.42889 12.4098 5.97347C12.6774 5.51804 13.0615 5.14211 13.5225 4.88433C13.988 4.62249 14.5149 4.48965 15.0489 4.49954C15.5829 4.50943 16.1045 4.66168 16.56 4.94058L43.575 21.4668C44.0109 21.7302 44.3712 22.1019 44.6209 22.5458C44.8707 22.9897 45.0012 23.4907 45 24Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.555fb0167d0b051001e00dafb450c9e8.svg";
export { ForwardRef as ReactComponent };